// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3I0FJ","label":"Category_label__3MxOk","content":"Category_content__Q9XPZ","header":"Category_header__4jNXE","location":"Category_location__OgtaJ"};